import React from 'react';
import ISVGIcon from './interfaces/ISVGIcon';

const AlertChunky = ({ fill }: ISVGIcon): React.ReactElement => (
    <svg viewBox="0 0 24 24">
        <path
            fill={fill}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12,18c-3.3,0-6-2.7-6-6 s2.7-6,6-6s6,2.7,6,6S15.3,18,12,18z M12,4c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S16.4,4,12,4z"
        />
        <rect
            className="eds-icon--alert-chunky_dot"
            x="11"
            y="14"
            fillRule="evenodd"
            clipRule="evenodd"
            width="2"
            height="2"
        />
        <rect
            className="eds-icon--alert-chunky_line"
            x="11"
            y="8"
            fillRule="evenodd"
            clipRule="evenodd"
            width="2"
            height="5"
        />
    </svg>
);

export default AlertChunky;
